import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { IBaseDisbursementType } from '../IBaseDisbursementType';
import { defaultCreate } from '../defaultCreate';
import { InternalTransferDisbursementContainer } from './InternalTransferDisbursementContainer';
import { InternalTransferStatusPill } from './InternalTransferStatusPill';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';

export interface IInternalTransferDisbursementType extends IBaseDisbursementType<eDisbursementType.InternalTransfer> { }

export const InternalTransferDisbursementType: IInternalTransferDisbursementType = {
  type: eDisbursementType.InternalTransfer,

  editPermission: ePermissions.EscrowExpectedInternalTransfersEdit,
  readPermission: ePermissions.EscrowExpectedInternalTransfersRead,

  create: (fee, order, isSpruceWithZillowEnabled, isZillowClosing) => {
    const { id, amountCents, isNew, statementFeeId } = defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing);
    return {
      id,
      type: eDisbursementType.InternalTransfer,
      amountCents,
      isNew,
      statementFeeId,
      holdback: false,
      holdbackProperties: {},
    };
  },
  container: InternalTransferDisbursementContainer,
  statusPill: InternalTransferStatusPill,
  isReadOnly: (x) => {
    if (x.type === eDisbursementType.InternalTransfer) {
      return !!x.enqueuedForDisbursementAt || !!x.completedAt;
    }
    return true;
  },
};
